import { FC, useMemo } from 'react';

import classNames from 'classnames';
import { useSwiper } from 'swiper/react';

import styles from './Slider.module.scss';

interface ISliderButtonsProps {
  isNextDisabled: boolean;
  isPrevDisabled: boolean;
  loop: boolean;
}

const SliderButtons: FC<ISliderButtonsProps> = ({
  isNextDisabled,
  isPrevDisabled,
  loop,
}) => {
  const swiper = useSwiper();
  const prevDisabled = useMemo(() => {
    if (loop) {
      return false;
    }
    return isPrevDisabled;
  }, [loop, isPrevDisabled]);
  const nextDisabled = useMemo(() => {
    if (loop) {
      return false;
    }
    return isNextDisabled;
  }, [loop, isNextDisabled]);

  const handlePrevious = () => {
    if (prevDisabled) {
      return;
    }
    swiper.slidePrev();
  };

  const handleNext = () => {
    if (nextDisabled) {
      return;
    }
    swiper.slideNext();
  };

  return (
    <div
      aria-label="Carousel navigation"
      className={styles.slider_buttons}
      role="navigation"
    >
      <button
        aria-label="Preview"
        className={classNames('slick-arrow slick-prev', {
          ['slick-disabled']: prevDisabled,
        })}
        onClick={handlePrevious}
        type="button"
      >
        <span className="sr-only">Previous</span>
      </button>
      <button
        aria-label="Next"
        className={classNames('slick-arrow slick-next', {
          ['slick-disabled']: nextDisabled,
        })}
        onClick={handleNext}
        type="button"
      >
        <span className="sr-only">Next</span>
      </button>
    </div>
  );
};

export { SliderButtons };
